import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicFormModule } from '@ot/shared/dynamic-form';
import { ClipboardModule } from 'ngx-clipboard';
import { ModalModule } from '../modal';

@NgModule({
  imports: [CommonModule, DynamicFormModule, ClipboardModule, ModalModule],
  declarations: [],
  exports: [CommonModule, DynamicFormModule, ClipboardModule, ModalModule]
})
export class CommonImportsModule {}
